module.exports = __webpack_public_path__ + "static/poster-666100f6fac35db3ca8792ccd7f5315a.png";